import { Component, OnInit } from '@angular/core';
import { ShipmentService } from '../../../data/shipment.service';
import { Observable, pairwise } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectRouteParam } from '../../../store/router/router.state';
import { filter, map, startWith, switchMap, take } from 'rxjs/operators';
import { ShipmentState } from '../../../utils/shipment-state';
import { ShipmentViewComponent } from '../shipment-view/shipment-view.component';
import { ShipmentPreparationComponent } from '../shipment-preparation/shipment-preparation.component';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { shipmentEditorLoadRequest } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-shipment-page',
    templateUrl: './shipment-page.component.html',
    styleUrls: ['./shipment-page.component.scss'],
    imports: [ ShipmentPreparationComponent, ShipmentViewComponent, AsyncPipe, RouterOutlet, MatProgressSpinner ]
})
export class ShipmentPageComponent implements OnInit {

  constructor(private store: Store<AppState>, private shipmentService: ShipmentService,
              private router: Router, public route: ActivatedRoute) { }

  shipmentId$: Observable<string> = this.store.select(selectRouteParam('id'));
  loading$: Observable<boolean> = this.shipmentService.loading$;
  editable$: Observable<boolean> = this.shipmentId$.pipe(
      switchMap(id => this.shipmentService.observeStatus(id)),
      map(status => ShipmentState.isQuotable(status))
  );

    initialLoading$ = this.shipmentId$.pipe(
        switchMap(id => this.shipmentService.observe(id)),
        map(shipment => !!shipment),
        startWith(false),
        pairwise(),
        map(([prev, curr]) => !prev && curr === false) // or simpler: !shipmentYet
    );

    ngOnInit(): void {
      this.route.data.pipe(take(1)).subscribe(({ shipment }) => {
          if (ShipmentState.isQuotable(shipment.statusCode)) {
              this.router.navigate(['edit'], { relativeTo: this.route, replaceUrl: true });
          } else {
              this.router.navigate(['view'], { relativeTo: this.route, replaceUrl: true });
          }
      });
  }

}
